<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="10">
        <el-form :model="monitorForm">
          <el-tabs type="border-card" @tab-click="handleClick">
            <el-tab-pane
              v-for="(item, index) in parkData"
              :label="item.name"
              :key="index"
            >
              <p style="font-size: 14px">已录入 {{ total }} 个地块</p>
              <el-table
                class="fromTable"
                :data="monitorForm.lands"
                height="484"
                style="width: 100%"
              >
                <el-table-column width="30">
                  <template slot="header">
                    <el-checkbox
                      type="success"
                      :indeterminate="isIndeterminate"
                    />
                  </template>
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.show" />
                  </template>
                </el-table-column>
                <el-table-column label="地块名">
                  <template slot-scope="scope">
                    {{ scope.row.name }}
                  </template>
                </el-table-column>
                <el-table-column width="160">
                  <template slot="header"> 面积 </template>
                  <template slot-scope="scope">
                    {{ scope.row.acreage | toFixed }} m<sup>2</sup> （
                    {{ scope.row.acreage | toM }} 亩）
                  </template>
                </el-table-column>
                <el-table-column width="130">
                  <template slot="header">
                    <!-- 新增地块的按钮 -->
                    <el-tooltip content="新增" placement="top">
                      <el-button
                        @click="formAdd()"
                        type="primary"
                        circle
                        size="large"
                        style="padding: 4px"
                        icon="el-icon-plus"
                      ></el-button>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-tooltip content="删除" placement="top">
                      <el-button
                        @click="remove(scope.row)"
                        icon="el-icon-delete"
                        type="danger"
                        circle
                        size="large"
                        style="padding: 4px"
                      />
                    </el-tooltip>
                    <el-tooltip content="编辑" placement="top">
                      <el-button
                        type="warning"
                        circle
                        size="large"
                        style="padding: 4px"
                        icon="el-icon-edit"
                        @click="updateFrom(scope.row)"
                      />
                    </el-tooltip>
                    <el-tooltip content="定位和绘制" placement="top">
                      <el-button
                        icon="el-icon-delete-location"
                        type="warning"
                        circle
                        size="large"
                        style="padding: 4px"
                        @click="$router.push(`land/locate/${scope.row.id}`)"
                      />
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 12px; text-align: center">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="value"
                  layout="prev, pager, next"
                  :total="total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </el-col>
      <el-col :span="14">
        <div
          id="landMap"
          style="
            height: 640px;
            background-color: #f3f3f3;
            text-align: center;
            line-height: 580px;
          "
        >
          <el-button type="primary" :disabled="btnStatus" @click="showMap"
            >显示地图</el-button
          >
          <!-- 地图显示地块 -->
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="title + '地块'"
      :visible.sync="dialogFormVisible"
      :before-close="cancel"
      width="50%"
    >
      <el-form
        label-width="80px"
        :model="form"
        label-position="right"
        :rules="monitorForm.monitorRules"
        ref="form"
        style="width: 50%; margin: 0px auto"
      >
        <el-form-item label="地块名" prop="name">
          <el-input size="mini" v-model="form.name" maxlength="30" />
        </el-form-item>
        <el-form-item label="面积" prop="volumn">
          <el-radio v-model="radio" label="1">平方米</el-radio>
          <el-radio v-model="radio" label="2">亩</el-radio>
          <el-input
            v-if="radio === '1'"
            suffix="m2"
            size="mini"
            v-model="form.volumn"
            maxlength="30"
          >
            <template slot="append"
              ><span>m<sup>2</sup></span></template
            >
          </el-input>
          <el-input
            v-if="radio === '2'"
            suffix="m2"
            size="mini"
            v-model="form.volumnMu"
            maxlength="30"
          >
            <template slot="append"><span>亩</span></template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="saveArea">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import map from '../park/map'
import { parkSearch } from '@/api/park.js'
import { getPark } from '@/api/park2.js'
import Map from './locate-map.js'
import { getLandInPark } from '@/api/land2.js'
import {
  getAreaData,
  addAreaData,
  removeAreaData,
  updateAreaData,
} from '@/api/land.js'
export default {
  name: 'LandIndex',
  data() {
    return {
      enterPriseId: this.$store.getters.currentEnterprise.id,
      areaId: undefined,
      dialogFormVisible: false,
      isIndeterminate: true,
      pageNum: 1,
      value: 10,
      total: 0,
      monitorForm: {
        lands: [],
        monitorRules: {
          code: [{ required: true, message: '编号不能为空', trigger: 'blur' }],
          name: [{ required: true, message: '地名不能为空', trigger: 'blur' }],
          volumn: [
            { required: true, message: '面积不能为空', trigger: 'blur' },
          ],
        },
      },
      form: {
        code: '',
        name: '',
        volumn: '',
        volumnMu: '',
      },
      /**
       * 按钮
       */
      radio: '1',
      parkData: [],
      parkId: undefined,
      mapLoaded: false,
      btnStatus: true,
      title: '',
    }
  },
  computed: {},
  filters: {
    toM(val) {
      return (val * 0.0015).toFixed(1)
    },
    toFixed(val) {
      return val.toFixed(1)
    },
  },
  watch: {
    mapLoaded: function () {
      this.parkDateGet()
    },
    radio(val) {
      if (val === '2') {
        // let data=this.form.volumnMu
        this.form.volumnMu = (0.0015 * this.form.volumn).toFixed(1)
      }
    },
  },
  methods: {
    landSearch() {
      let option = {
        pageNum: this.pageNum,
        pageSize: 0,
        enterpriseId: this.$store.getters.currentEnterprise.id,
        packName: null,
        parkId: this.parkId,
      }
      getAreaData(option).then((data) => {
        this.monitorForm.lands = data.data.list
        this.total = data.data.total
      })
    },
    handleClick(tab, event) {
      let id = this.parkData[tab.index * 1].id
      this.parkId = id
      let option = {
        pageNum: 1,
        pageSize: this.value,
        enterpriseId: this.$store.getters.currentEnterprise.id,
        packName: null,
        parkId: id,
      }
      //获取园区经纬度
      this.landSearch()
      this.parkDateGet()
    },
    parkDataget() {
      this.enterpriseId = this.$store.getters.currentEnterprise.id
      let option = {
        pageNum: 1,
        pageSize: 100000,
        enterpriseId: this.$store.getters.currentEnterprise.id,
        name: null,
      }
      parkSearch(option).then((data) => {
        this.parkData = data.data.lists
      })
    },
    remove(row) {
      removeAreaData({ id: row.id }).then((data) => {
        this.$message.success('删除成功')
        this.landSearch()
      })
    },
    handleSizeChange(val) {
      this.value = val
      this.pageNum = 1
      this.landSearch()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.landSearch()
    },
    cancel(form) {
      this.form.id = undefined
      this.dialogFormVisible = false
      this.$refs[form].resetFields()
    },
    fromSubmit(row) {
      if (row.code != '' && row.name != '' && row.volumn != '') {
        row.add = false
      } else {
        this.$message.error('编号地块名和面积都不能为空')
      }
    },
    formAdd() {
      this.dialogFormVisible = true
      this.title = '新增'
      this.areaId = undefined
    },
    saveArea() {
      if (this.radio === '2') {
        this.form.volumn = parseInt(666.6666667 * Number(this.form.volumnMu))
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          let option = {}
          option.name = this.form.name
          option.acreage = this.form.volumn
          option.parkId = this.parkId
          option.enterpriseId = this.$store.getters.currentEnterprise.id

          if (this.areaId) {
            option.id = this.areaId
            updateAreaData(option).then((data) => {
              this.areaId = undefined
              this.landSearch()
              this.dialogFormVisible = false
              this.$refs['form'].resetFields()
              this.$message.success('提交成功')
            })
          } else {
            let option = {}
            option.name = this.form.name
            option.acreage = this.form.volumn
            option.parkId = this.parkId
            option.enterpriseId = this.$store.getters.currentEnterprise.id
            addAreaData(option).then((data) => {
              this.pageNum = 1
              this.landSearch()
              this.dialogFormVisible = false
              this.$refs['form'].resetFields()
              this.$message.success('提交成功')
            })
          }
        }
      })
    },
    updateFrom(row) {
      this.title = '编辑'
      this.dialogFormVisible = true
      this.areaId = row.id
      this.form.id = row.id
      this.form.name = row.name
      this.form.volumn = row.acreage.toFixed(1)
    },

    parkDateGet() {
      getPark(this.parkId).then((r) => {
         if (this.mapLoaded) {
        getLandInPark(this.parkId).then((data) => {
          if (data) {
            let arr = data.data
            arr.push(...r.data)
            Map.drawPark(arr)
          }
        })
         }
      })

    },
    showMap() {
      Map.init('landMap', this)
    },
  },
  created() {},
  mounted() {
    this.enterpriseId = this.$store.getters.currentEnterprise.id
    parkSearch({
      pageNum: 1,
      pageSize: 10,
      enterpriseId: this.$store.getters.currentEnterprise.id,
      packName: null,
    })
      .then((data) => {
        this.parkData = data.data.list
      })
      .then((data) => {
        let id = this.parkData[0].id
        this.parkId = id
        let option = {
          pageNum: 1,
          pageSize: 10,
          enterpriseId: this.enterpriseId,
          name: null,
          parkId: this.parkId,
        }
        getAreaData(option).then((data) => {
          this.monitorForm.lands = data.data.list
          this.total = data.data.total
          if (data) {
            this.btnStatus = false
          }
        })
      })
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    Map.destroy()
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/meta/land/Index.vue